import React, {FC, Suspense, useCallback, useState, lazy} from 'react'
import {retry} from '@rambler-id/promise'
import {useViewport} from '@rambler-id/react'
import {GeoPopup} from './GeoPopup'

const fallbackElement = <div />

const DesktopTopline = lazy(
  retry(() => import(/* webpackChunkName: "topline" */ './Desktop'))
)

const MobileTopline = lazy(
  retry(() => import(/* webpackChunkName: "mobile-topline" */ './Mobile'))
)

export const Topline: FC = () => {
  const {isMobile} = useViewport([1024])

  const [geoOpened, setGeoOpened] = useState(false)
  const [reloadGeoKey, setReloadGeoKey] = useState(0)

  const onOpenGeo = useCallback(() => {
    setGeoOpened(true)
  }, [])

  const onCloseGeo = useCallback(() => {
    setGeoOpened(false)
  }, [])

  const onChangeGeo = useCallback(() => {
    setReloadGeoKey(reloadGeoKey + 1)
  }, [reloadGeoKey])

  return (
    <>
      <Suspense fallback={fallbackElement}>
        {isMobile ? (
          <MobileTopline onOpenGeo={onOpenGeo} />
        ) : (
          <DesktopTopline onOpenGeo={onOpenGeo} />
        )}
      </Suspense>
      <GeoPopup
        geoOpened={geoOpened}
        onChange={onChangeGeo}
        onClose={onCloseGeo}
      />
    </>
  )
}
